import { render } from "./TriggerDescription.vue?vue&type=template&id=0ca01e22"
import script from "./TriggerDescription.vue?vue&type=script&lang=js"
export * from "./TriggerDescription.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__